export type BackofficeUserType =
  | 'client'
  | 'pro_driver'
  | 'community_driver'
  | 'admin'
  | 'super_admin';

export interface RoleTheme {
  color: string;
  label: string;
  logoGradient: string;
  logoShadow: string;
  activeNav: string;
  activeNavText: string;
  activeIcon: string;
  badge: string;
  badgeText: string;
  focusRing: string;
  link: string;
  linkHover: string;
}

export const ROLE_THEMES: Record<BackofficeUserType, RoleTheme> = {
  client: {
    color: 'teal',
    label: 'Client',
    logoGradient: 'from-teal-600 to-teal-700',
    logoShadow: 'shadow-teal-500/30',
    activeNav: 'bg-teal-50',
    activeNavText: 'text-teal-700',
    activeIcon: 'text-teal-600',
    badge: 'bg-teal-100',
    badgeText: 'text-teal-700',
    focusRing: 'focus:ring-teal-500',
    link: 'text-teal-600',
    linkHover: 'hover:text-teal-700',
  },
  community_driver: {
    color: 'orange',
    label: 'Livreur communautaire',
    logoGradient: 'from-orange-500 to-orange-600',
    logoShadow: 'shadow-orange-500/30',
    activeNav: 'bg-orange-50',
    activeNavText: 'text-orange-700',
    activeIcon: 'text-orange-600',
    badge: 'bg-orange-100',
    badgeText: 'text-orange-700',
    focusRing: 'focus:ring-orange-500',
    link: 'text-orange-600',
    linkHover: 'hover:text-orange-700',
  },
  pro_driver: {
    color: 'blue',
    label: 'Livreur professionnel',
    logoGradient: 'from-blue-600 to-blue-700',
    logoShadow: 'shadow-blue-500/30',
    activeNav: 'bg-blue-50',
    activeNavText: 'text-blue-700',
    activeIcon: 'text-blue-600',
    badge: 'bg-blue-100',
    badgeText: 'text-blue-700',
    focusRing: 'focus:ring-blue-500',
    link: 'text-blue-600',
    linkHover: 'hover:text-blue-700',
  },
  admin: {
    color: 'indigo',
    label: 'Administrateur',
    logoGradient: 'from-indigo-600 to-indigo-700',
    logoShadow: 'shadow-indigo-500/30',
    activeNav: 'bg-indigo-50',
    activeNavText: 'text-indigo-700',
    activeIcon: 'text-indigo-600',
    badge: 'bg-indigo-100',
    badgeText: 'text-indigo-700',
    focusRing: 'focus:ring-indigo-500',
    link: 'text-indigo-600',
    linkHover: 'hover:text-indigo-700',
  },
  super_admin: {
    color: 'violet',
    label: 'Super administrateur',
    logoGradient: 'from-violet-600 to-violet-700',
    logoShadow: 'shadow-violet-500/30',
    activeNav: 'bg-violet-50',
    activeNavText: 'text-violet-700',
    activeIcon: 'text-violet-600',
    badge: 'bg-violet-100',
    badgeText: 'text-violet-700',
    focusRing: 'focus:ring-violet-500',
    link: 'text-violet-600',
    linkHover: 'hover:text-violet-700',
  },
};

const BACKEND_ROLE_MAP: Record<string, BackofficeUserType> = {
  client: 'client',
  community_delivery: 'community_driver',
  professional_delivery: 'pro_driver',
  admin: 'admin',
  super_admin: 'super_admin',
};

export function mapRoleToUserType(roleCode: string): BackofficeUserType {
  return BACKEND_ROLE_MAP[roleCode] ?? 'client';
}

export function getRoleTheme(userType: BackofficeUserType): RoleTheme {
  return ROLE_THEMES[userType];
}
